import React, { useState, useEffect } from 'react';
import { documentService } from '../services/documentService';
import { API_URL } from '../utils/apiConfig';

const PreviewDebugger = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadDocuments = async () => {
      try {
        const docs = await documentService.getUserDocuments(1, 10, 'uploaded', '', 'all');
        setDocuments(docs);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    loadDocuments();
  }, []);

  const constructPreviewUrl = (documentId) => {
    const token = localStorage.getItem('token');
    return `${API_URL}/documents/${documentId}/preview${token ? `?token=${encodeURIComponent(token)}` : ''}`;
  };

  if (loading) return <div className="p-4">Loading documents...</div>;
  if (error) return <div className="p-4 text-red-500">Error: {error}</div>;

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Document Preview Debugger</h2>
      
      <div className="mb-4">
        <h3 className="text-lg font-semibold mb-2">Environment Info:</h3>
        <ul className="text-sm space-y-1">
          <li><strong>API URL:</strong> {API_URL}</li>
          <li><strong>Has Token:</strong> {localStorage.getItem('token') ? 'Yes' : 'No'}</li>
          <li><strong>Token Preview:</strong> {localStorage.getItem('token')?.substring(0, 20) + '...' || 'None'}</li>
        </ul>
      </div>

      <div className="space-y-4">
        <h3 className="text-lg font-semibold">Documents ({documents.length}):</h3>
        {documents.slice(0, 5).map(doc => (
          <div key={doc.id} className="border rounded-lg p-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <h4 className="font-medium">{doc.name}</h4>
                <div className="text-sm text-gray-600 space-y-1">
                  <p><strong>ID:</strong> {doc.id}</p>
                  <p><strong>File Type:</strong> {doc.fileType}</p>
                  <p><strong>Preview Generated:</strong> {doc.previewGenerated ? 'Yes' : 'No'}</p>
                  <p><strong>Preview URL:</strong> {doc.previewUrl || 'None'}</p>
                </div>
              </div>
              <div>
                <p className="text-sm font-medium mb-2">Preview Test:</p>
                {doc.previewGenerated && doc.previewUrl ? (
                  <div className="space-y-2">
                    <p className="text-xs text-gray-500">Preview URL: {constructPreviewUrl(doc.id)}</p>
                    <img 
                      src={constructPreviewUrl(doc.id)}
                      alt={`Preview of ${doc.name}`}
                      className="w-32 h-24 object-cover border rounded"
                      onLoad={() => console.log('✅ Preview loaded for:', doc.name)}
                      onError={(e) => {
                        console.error('❌ Preview failed for:', doc.name);
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'block';
                      }}
                    />
                    <div className="text-red-500 text-sm hidden">
                      Failed to load preview
                    </div>
                  </div>
                ) : (
                  <div className="w-32 h-24 bg-gray-200 rounded flex items-center justify-center text-xs">
                    No preview
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-gray-50 rounded-lg">
        <h3 className="font-semibold mb-2">Test Actions:</h3>
        <button 
          onClick={() => window.location.reload()}
          className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
        >
          Reload Page
        </button>
        <button 
          onClick={() => {
            const testDoc = documents.find(d => d.previewGenerated);
            if (testDoc) {
              const url = constructPreviewUrl(testDoc.id);
              window.open(url, '_blank');
            }
          }}
          className="bg-green-500 text-white px-4 py-2 rounded"
        >
          Test Preview URL
        </button>
      </div>
    </div>
  );
};

export default PreviewDebugger; 